module.exports = __webpack_public_path__ + "img/zz2.865631fa.jpg";